import Form from "./Form";
import { GlobalStyle } from "./GlobalStyle";

function App() {

  return (
    <div className="container">
      <GlobalStyle />
      <Form />
    </div>
  );
}
export default App;
